import React, { Component } from 'react';
import './../css/master.css';
import './../css/wvrDone.css';
import WeaverHeader from './../js/weaverHeader.js';
import axiosInstance from '../api/wvrAxios';
import $ from 'jquery';
import 'react-datepicker/dist/react-datepicker.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReactImageMagnify from 'react-image-magnify';
import DatePicker from 'react-datepicker';
//import moment from 'moment';

var httpURL = '';
var queryString = require('querystring');
var lstWorkDone = [];
var lstMachines = [];

class WVRDone extends Component {
	constructor(props) {
		super(props);
		this.state = {
			designImagePath: require('./../images/blank.png'),
			loader: 'none',
			opacity: 1,
			transporter: '',
			contactPerson: '',
			phone: '',
			workDone: [],
			machines: [],
			workDoneDate: null,
			totalQuantity: 0,
			quantityColor: '',
		}
	}

	handleWorkDone = (date) => {
		this.setState({ workDoneDate: date });
	}

	async componentDidMount() {
		var details = this.props.location.state.detail;

		$('#ipoId').val(details.ipoId);
		$('#ipoNo').val(details.ipoNo);
		$('#ipoDesignId').val(details.ipoDesignId);
		$('#designId').val(details.designId);
		$('#designNoColor').val(details.designNoColor);
		$('#quality').val(details.quality);
		$('#length').val(details.length);
		$('#width').val(details.width);
		$('#yarnCount').val(details.yarnCount);
		$('#construction').val(details.construction);

		this.setState({ loader: 'block', opacity: 0.5, designImagePath: details.imageUrl });

		axiosInstance.post(httpURL + '/w/po/work/lstmachines',
			queryString.stringify({ 'ipoDesignId': $('#ipoDesignId').val() }), { withCredentials: true }
		).then((response) => {
			if (response.data.SvcStatus === 'Success') {
				this.setState({
					machines: response.data.lstMachines,
				});
				lstMachines = this.state.machines;
				this.fillMachineCmb();
			}
			else {
				toast.error(response.data.SvcMsg);
				if (response.data.SvcMsg == 'No Machines exist for this IPO Design') {
					lstMachines = [];
					this.fillMachineCmb();
				}

				if (response.data.SvcMsg == 'You are not logged in') {
					window.location.href = window.WVRURL;
					return false;
				}
			}
			this.setState({ loader: 'none', opacity: 1 });
		}).catch((error) => {
			toast.error("Service failed " + error);
		});

		axiosInstance.post(httpURL + '/w/po/work/lstworkdone',
			queryString.stringify({ 'ipoDesignId': $('#ipoDesignId').val() }), { withCredentials: true }
		).then((response) => {
			if (response.data.SvcStatus === 'Success') {
				this.setState({
					workDone: response.data.lstWorkDone,
					totalQuantity: response.data.totalQuantity,
					quantityColor: $('#length').val() > response.data.totalQuantity ? 'red' : 'green',
				});
				lstWorkDone = this.state.workDone;
				$('#order_completed').prop('checked', response.data.orderCompleted);
				if (response.data.orderCompleted == true) {
					$('#newWorkDone input, button, select').attr('disabled', true);
				}
				this.setWorkDoneTable();
			}
			else {
				toast.error(response.data.SvcMsg);
				if (response.data.SvcMsg == 'No WorkDone Data exist for this IPO Design') {
					lstWorkDone = [];
					this.setWorkDoneTable();
				}

				if (response.data.SvcMsg == 'You are not logged in') {
					window.location.href = window.WVRURL;
					return false;
				}
			}
			this.setState({ loader: 'none', opacity: 1 });
		}).catch((error) => {
			toast.error("Service failed " + error);
		});

		this.handleResize();
		window.addEventListener("load", this.handleResize);
		window.addEventListener("resize", this.handleResize);
	}

	handleResize = () => {
		var width1 = ($('.tableLayout1').parent().width()) - 17;
		this.setState({ width1: width1 })
	}

	fillMachineCmb() {
		$('#cmb_Machine').empty();
		$('#cmb_Machine').prepend($("<option> </option>").val(0).html('Machine Type'));
		for (var i = 0; i < lstMachines.length; i++) {
			var machineTypeId = lstMachines[i].machineTypeId;
			var machineType = lstMachines[i].machineType;
			$('#cmb_Machine').append($("<option> </option>").val(machineTypeId).html(machineType));
		}
	}

	setWorkDoneTable = () => {
		$('#workDoneTbody tr').remove();
		var table = document.getElementById('workDoneTable');
		var tbody = document.getElementById('workDoneTbody');

		for (var i = 0; i < lstWorkDone.length; i++) {
			var workDoneDt = lstWorkDone[i].workDoneDt;
			var machineType = lstWorkDone[i].machineType;
			var quantity = lstWorkDone[i].quantity;

			var row = document.createElement('tr');
			this.addTD(row, workDoneDt, 'text-center');
			this.addTD(row, machineType, '');
			this.addTD(row, quantity, 'text-right');

			tbody.append(row);
		}
		table.append(tbody);
	}

	addTD(row, val, classname) {
		var cell = document.createElement('td');
		cell.className = classname;
		var text = document.createTextNode(val);
		cell.append(text);
		row.append(cell);
	}

	saveWorkDone = () => {
		var workDone = {};
		var ipoDesignId = $('#ipoDesignId').val();
		var workDoneDt = $('#workDoneDt').val();
		var quantity = $('#inp_quantity').val();
		var length = $('#length').val();
		var machineTypeId = $('#cmb_Machine').find('option:selected').val();
		var machineType = $('#cmb_Machine').find('option:selected').text();
		var weaverId = sessionStorage.getItem('weaverId');
		if (workDoneDt == '') {
			toast.warning('Please fill work done date');
			return false;
		}

		if (machineTypeId == 0) {
			toast.warning('Please select machine');
			return false;
		}

		if (quantity == '') {
			toast.warning('Please fill quantity');
			return false;
		}
		workDone = { ipoDesignId, workDoneDt, machineTypeId, quantity, weaverId, length };
		var x = window.confirm('You can not change work done after save');

		if (x) {
			this.setState({ loader: 'block', opacity: 0.5 });
			axiosInstance.post(httpURL + '/w/po/work/save',
				queryString.stringify({ 'workDone': JSON.stringify(workDone) }), { withCredentials: true }
			).then((response) => {
				if (response.data.SvcStatus === 'Success') {
					toast.success(response.data.SvcMsg);
					workDone.machineType = machineType;
					lstWorkDone.unshift(workDone);
					this.setWorkDoneTable();
					$('#workDoneDt').val('');
					$('#inp_quantity').val('');
					$('#cmb_Machine').val(0);
					this.setState({
						workDoneDate: null,
						totalQuantity: response.data.totalQuantity,
						quantityColor: $('#length').val() > response.data.totalQuantity ? 'red' : 'green',
					});
				}
				else {
					toast.error(response.data.SvcMsg);
					if (response.data.SvcMsg == 'You are not logged in') {
						window.location.href = window.WVRURL;
						return false;
					}
				}
				this.setState({ loader: 'none', opacity: 1 });
			}).catch((error) => {
				toast.error("Service failed " + error);
			});
		}
	}

	render() {
		httpURL = window.httpURL;
		return (
			<div style={{ height: '100%' }}>
				<WeaverHeader />
				<ToastContainer autoClose={2000} hideProgressBar />
				<div style={{ position: 'fixed', width: 100, height: 100, marginLeft: -50, marginTop: -50, left: '50%', top: '50%', display: this.state.loader, zIndex: 9999 }}>
					<img src={require("../images/loader.gif")} alt="Loader..." />
				</div>
				<div className="main" style={{ opacity: this.state.opacity }}>
					<div className="container-fluid">
						<div className="col-sm-12 col-centered">
							<div className="row">
								<div className="col-sm-10" style={{ paddingLeft: 0 }}>
									<div className="styleBackground">
										<form className="form-inline">
											<div className="form-group">
												<label style={{ width: 60 }} htmlFor="ipoNo">IPO NO:</label>
												<input style={{ display: 'none' }} placeholder="IPO Id" type="text" className="form-control" id="ipoId" />
												<input style={{ display: 'none' }} placeholder="IPO Design Id" type="text" className="form-control" id="ipoDesignId" />
												<input style={{ marginLeft: 5 }} readOnly placeholder="IPO Number" type="text" className="form-control" id="ipoNo" />
											</div>
											<div className="form-group">
												<label style={{ marginLeft: 10, width: 100 }} htmlFor="designNoColor">Design Color:</label>
												<input style={{ display: 'none' }} placeholder="Design Id" type="text" className="form-control" id="designId" />
												<input style={{ marginLeft: 5 }} readOnly placeholder="Design Color" type="text" className="form-control" id="designNoColor" />
											</div>
											<div className="form-group">
												<label style={{ marginLeft: 10, width: 60 }} htmlFor="quality">Quality:</label>
												<input style={{ marginLeft: 5 }} readOnly placeholder="Quality" type="text" className="form-control" id="quality" />
											</div>
										</form>
										<form className="form-inline" style={{ marginTop: 5 }}>
											<div className="form-group">
												<label style={{ marginLeft: 0, width: 60 }} htmlFor="width">Width:</label>
												<input style={{ marginLeft: 5 }} readOnly placeholder="Width" type="text" className="form-control" id="width" />
											</div>
											<div className="form-group">
												<label style={{ marginLeft: 10, width: 100 }} htmlFor="yarnCount">Yarn Count:</label>
												<input style={{ marginLeft: 5 }} readOnly placeholder="Yarn Count" type="text" className="form-control" id="yarnCount" />
											</div>
											<div className="form-group">
												<label style={{ marginLeft: 10, width: 60 }} htmlFor="length">Length:</label>
												<input style={{ marginLeft: 5, width: 100 }} readOnly placeholder="Length" type="text" className="form-control text-right" id="length" />
											</div>

											<div className="form-group">
												<label style={{ marginLeft: 10 }} htmlFor="construction">Construction:</label>
												<input style={{ marginLeft: 5, width: 100 }} readOnly placeholder="Construction" type="text" className="form-control" id="construction" />
											</div>
										</form>
									</div>
									<div style={{ marginTop: 5, display: 'flex', flexDirection: 'row', position: 'relative' }} className="styleBackground">
										<h4 style={{ fontWeight: 'bold', color: '#bb592b', width: 200 }}>New Work</h4>
										<form className="form-inline" id="newWorkDone">
											<div className="form-group">
												<label style={{ width: 120 }} htmlFor="workDoneDt">Work Done Date:<span style={{ color: 'red' }}>*</span></label>
												<div style={{ display: 'inline-block', width: 120 }}>
													<DatePicker id="workDoneDt"
														className='form-control inline-width text-center'
														placeholderText="Work Done Date"
														selected={this.state.workDoneDate}
														onChange={this.handleWorkDone}
														dateFormat="dd-MM-yyyy"
														autoComplete='off'
													//minDate= {new Date()}
													/>
												</div>
											</div>
											<div style={{ marginLeft: 20 }} className="form-group">
												<label htmlFor="cmb_Machine">Machine Type:<span style={{ color: 'red' }}>*</span></label>
												<select style={{ marginLeft: 2, width: 120 }} id="cmb_Machine" className='form-control' />
												<label style={{ marginLeft: 20 }} htmlFor="inp_quantity">Quantity:<span style={{ color: 'red' }}>*</span></label>
												<input style={{ marginLeft: 2, width: 120 }} type="text" id="inp_quantity" placeholder="Quantity" className='form-control text-right' />
											</div>
											<button style={{ position: 'absolute', right: 10 }} onClick={this.saveWorkDone} type="button" className="btn btn-warning">Save</button>
										</form>
									</div>
								</div>
								<div className="col-sm-2 padding-remove" id="designColorImageDiv3">
									<ReactImageMagnify {...{
										smallImage: {
											alt: 'Design Image',
											src: this.state.designImagePath,
											isFluidWidth: true,
										},
										largeImage: {
											src: this.state.designImagePath,
											width: 600,
											height: 900
										},
										enlargedImageContainerDimensions: {
											width: 300,
											height: 300,
										},
										enlargedImageContainerStyle: {
											left: -170,
											top: 140,
										},
									}} />
								</div>
							</div>
							<div className="row styleBackground" style={{ paddingBottom: 20, marginTop: 10, display: 'flex', flexDirection: 'row' }}>
								<h4 style={{ fontWeight: 'bold', color: '#bb592b', width: 200 }}>Work History</h4>
								<div className="col-sm-5 padding-remove" style={{ marginTop: 10 }}>
									<table className="tableLayout1" style={{ width: this.state.width1 }}>
										<thead>
											<tr>
												<th style={{ width: 50 }}>Work Done Date</th>
												<th style={{ width: 100 }}>Machine Type</th>
												<th style={{ width: 50 }}>Quantity</th>
											</tr>
										</thead>
									</table>
									<div style={{ height: 300, overflowY: 'scroll' }}>
										<table className="tableLayout" id="workDoneTable">
											<colgroup>
												<col style={{ width: 50 }} />
												<col style={{ width: 100 }} />
												<col style={{ width: 50 }} />
											</colgroup>
											<tbody id="workDoneTbody"></tbody>
										</table>
									</div>
								</div>
								<div className="row" style={{ marginTop: 5, marginLeft: 25 }}>
									<div className="form-inline" style={{ marginLeft: 5 }}>
										<label htmlFor="">Order Completed:</label>
										<div className="checkbox" style={{ marginLeft: 5 }}>
											<input disabled type="checkbox" id="order_completed" />
										</div>
									</div>
									<span className="digitalFont" style={{ fontSize: 20, fontWeight: 'bold', color: this.state.quantityColor }}>Total Quantity: {this.state.totalQuantity}</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default WVRDone;
